import { Result } from "appworks/model/gameplay/records/results/result";

export class PopScatterResult extends Result {
    public resultType: string = "PopScatterResult";

    public matches: number;
}